





















import Vue from "vue";
// import AuthUtil, { User } from "@/auth/authUtil";

export default Vue.extend({
  name: "UserInfo",
  methods: {
    async login() {
      console.log(this.$root.$data);
      this.$root.$emit("login");
    },
    async logout() {
      this.$root.$emit("logout");
    }
  },
  data() {
    return {};
  },
  computed: {
    user(): any {
      return this.$root.$data.user;
    }
  }
});
